import { Response } from 'miragejs'
import type { MockServer, MirageServer } from './server.js'

export function routes(server: MockServer) {
  server.post(
    '/animal_lookups',
    function (this: MirageServer, _schema, request) {
      const { data } = JSON.parse(request.requestBody)
      const { search_field, search_term, species_id } = data.attributes

      if (!search_term?.trim()) {
        return new Response(
          400,
          {},
          {
            errors: [{ detail: 'search_term is required.' }],
          },
        )
      }

      if (search_term.startsWith('999')) {
        const channel = species_id
          ? `animal-${search_field}-${search_term}-species-${species_id}`
          : `animal-${search_field}-${search_term}`

        return new Response(
          202,
          {},
          {
            data: {
              type: 'AnimalLookup',
              id: '3',
              attributes: {
                search_field,
                search_term,
                species_id: species_id ?? null,
                status: 'PENDING',
                result: null,
                websocket_channel: channel,
              },
            },
          },
        )
      }

      const hasResult = !search_term.startsWith('000')

      if (hasResult) {
        return {
          data: {
            type: 'AnimalLookup',
            id: '1',
            attributes: {
              search_field,
              search_term,
              species_id: species_id ?? null,
              status: 'COMPLETED',
              result: {
                species: species_id ?? 1,
                breed: null,
                raw_breed: 'Miniature Schnauzer, black',
                microchip: '981098108416322',
                register_number: 'FI49974/21',
                official_name: "GREEDY RASCAL'S GROOVY LOVE",
                date_of_birth: '2021-07-09',
                color: 'black',
                gender: 'MALE',
                raw_gender: 'U',
                remarks:
                  'Registry dog id: 123456\nRegistry brood id: 321321\nSire reg: FI0000000/00\nSire name: LOREM IPSUM DOLOR SIT AMET CANIS\nDam reg: FI0000000/01. Registry dog id: 123456\nRegistry brood id: 321321\nSire reg: FI0000000/00\nSire name: LOREM IPSUM DOLOR SIT AMET CANIS\nDam reg: FI0000000/01.',
              },
              websocket_channel: null,
            },
          },
        }
      }

      return {
        data: {
          type: 'AnimalLookup',
          id: '2',
          attributes: {
            search_field,
            search_term,
            species_id: species_id ?? null,
            status: 'NO_RESULT',
            result: null,
            websocket_channel: null,
          },
        },
      }
    },
  )
}
